module.exports = __webpack_public_path__ + "img/t4-x2.be8546fb.svg";